module.exports = __webpack_public_path__ + "media/images/riders/SABINE_SPITZ-6fb3b44079abee4d22ff1593b9339490.png";